import { diagnosticSettings, diagnosticParameters } from './shared.js';

export default {
  label: 'Third-Order Aberrations', group: 'performance',
  description: 'Third-order (Seidel) aberration contributions of each surface, with system totals.',
  settingsSchema: diagnosticSettings,
  parameters: diagnosticParameters,
  coverage: 'Aspheric contributions are listed separately. Diffractive surfaces are excluded from the totals.',
} as const;
